import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";
import { KnownAction, SUBMIT_EMAIL, SELECT_COMMUNICATION_METHOD, ADD_USER_ID } from "./types";
import { History } from "history";

export const actionCreators = {
    submitEmail:
        (email: string, history: History): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: SUBMIT_EMAIL, email: email });
            history.push("/security-question-answer");
        },

    resetEmail: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: SUBMIT_EMAIL, email: "" });
    },

    addUserData:
        (userId: string, email: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: ADD_USER_ID, userId: userId });
            dispatch({ type: SUBMIT_EMAIL, email: email });
        },

    submitSecurityQuestionAnswer:
        (securityQuestionAnswerData: any, history: History): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            if (securityQuestionAnswerData.isValidSecurityAnswer) {
                history.push("/reset-password");
            }
        },

    submitCommunicationMethod:
        (methodType: string, history: History): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const requestBody = {
                methodType,
            };

            httpClient
                .sendRequest("POST", `web/forgot-password/generate-temporary-password`, requestBody)
                .then((data) => {
                    history.push("/validate-password");
                })
                .catch(function (error) {});

            dispatch({ type: SELECT_COMMUNICATION_METHOD, selectedMethod: methodType });
        },
};
